import { useMutation } from "react-query";
import { postData } from "../../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";
import { appInsights } from "../../../../config/appInsights";
import {
  IGenerateTempPinResponse,
  IGenerateUserTempPinPayload,
} from "../interfaces/temporaryPin";

const generateTemporaryPin = async (
  payload: IGenerateUserTempPinPayload,
): Promise<IGenerateTempPinResponse> => {
  const { data } = await postData(
    ajaxEndpoints.USER_TEMP_PIN_GENERATION,
    payload,
  );
  return data;
};

export function useGenerateTemporaryPin() {
  const [mutate, result] = useMutation(
    (payload: IGenerateUserTempPinPayload) => generateTemporaryPin(payload),
    {
      onError: (error) => {
        appInsights.trackException({
          exception: error,
          properties: { fileName: "useGenerateTemporaryPin.ts" },
        });
      },
    },
  );

  return { mutate, result };
}
